// 文件名: App.js
import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext.jsx'; 
import {ServiceProvider} from './context/ServiceContext.jsx';
import { LocationProvider } from './context/LocationContext.jsx';
import Restaurant from './pages/restaurant/Restaurant.jsx';
import LandingPage from './pages/landingPage/LandingPage.jsx';
import MenuList from './pages/menuList/MenuList.jsx';
import OrderResult from './pages/order/OrderResult.jsx';
import LocationDistance from './pages/location/LocationDistance.jsx';
import Warning from './pages/warning/Warning.jsx';
import Unavailable  from './pages/unavailable/Unavailable.jsx'; 
import DisableQR  from './pages/unavailable/DisableQR.jsx'; 
import OrderDetails from './pages/order/OrderDetails.jsx';

import OrderReview from './pages/order/OrderReview.jsx';

import OnlineOrderLogin from './pages/onlineOrderLogin/OnlineOrderLogin.jsx';
import AdminList from './pages/adminList/AdminList.jsx';
import AdminStoreConfig from './pages/adminStoreConfig/AdminStoreConfig.jsx';
import AdminMenuList from './pages/adminMenuList/AdminMenuList.jsx';
import EnrichAdmin from './pages/adminMenuList/EnrichAdmin.jsx';
import AdminTableSetup from './pages/adminTableSetup/AdminTableSetup.jsx';
import AdminMenuGroup from './pages/adminMenuGroup/AdminMenuGroup.jsx';
import OrderTest from './pages/order/orderTest.jsx';



function App() {

  // 标记 token 是否已处理完成
  const [tokenReady, setTokenReady] = React.useState(false);

  useEffect(() => {
    const originalOnError = window.onerror;

    window.onerror = (message, source, lineno, colno, error) => {
      if (typeof message === 'string' && message.includes('Invalid origin')) {
        console.warn("Ignored 'Invalid origin' error:", message);
        return true; // 阻止 React 抛出错误界面
      }
      if (originalOnError) {
        return originalOnError(message, source, lineno, colno, error);
      }
      return false;
    };

    return () => {
      window.onerror = originalOnError; // 组件卸载时恢复 window.onerror
    };
  }, []);

  // 全局处理从 Report 跳转带来的 token（必须在所有组件渲染前完成）
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('fromreporttoken=')) {
      const tokenMatch = hash.match(/fromreporttoken=(.+)/);
      if (tokenMatch && tokenMatch[1]) {
        const receivedToken = decodeURIComponent(tokenMatch[1]);
        if (receivedToken) {
          sessionStorage.setItem('jwtToken', receivedToken);
          // 清除 URL 中的 hash（为了安全）
          window.history.replaceState(null, '', window.location.pathname + (window.location.search || ''));
        }
      }
    }
    // 标记 token 处理完成（无论是否有 token）
    setTokenReady(true);
  }, []);

  // 等待 token 处理完成后再渲染路由
  if (!tokenReady) {
    return null; // 或者返回一个 loading 组件
  }

  return (
    
    <ServiceProvider> {/* 使用 OrderProvider 包裹整个应用 */}
    <CartProvider> {/* 使用 CartProvider 包裹整个应用 */}
    <LocationProvider>
      <Router>
        <Routes>
          <Route path="/qr_order/adminLogin" element={<OnlineOrderLogin />} />
          <Route path="/qr_order/adminOrderList" element={<AdminList />} />
          <Route path="/qr_order/adminMenuList" element={<AdminMenuList />} />
          <Route path="/qr_order/adminTableSetup" element={<AdminTableSetup />} />
          <Route path="/qr_order/adminStoreConfig" element={<AdminStoreConfig />} />
          <Route path="/qr_order/adminMenuGroup" element={<AdminMenuGroup />} />
          
          <Route path='/qr_order/adminEnrich/:storeId/:token' element={<EnrichAdmin />} /> 
          {/* <Route path="/qr_order/:restaurantUrl" element={<Restaurant />} /> */}
          <Route path='/qr_order/:restaurantUrl/:tableNo/landing' element={<LandingPage />} />
          <Route path="/qr_order/:restaurantUrl/:tableNo" element={<MenuList />} />
          <Route path="/qr_order/:restaurantUrl/:tableNo/orderReview" element={<OrderReview />} />
          {/* <Route path="/qr_order/:restaurantUrl/menu" element={<MenuList />} /> */}
          <Route path="/qr_order/:restaurantUrl/order/:orderId" element={<OrderDetails />} />
          <Route path="/qr_order/:restaurantUrl/order" element={<OrderDetails />} />
          {/* <Route path="/qr_order/:restaurantUrl/order" element={<OrderTest />} /> */}
          <Route path="/warning" element={<Warning />} />
          <Route path="/unavailable" element={<Unavailable />} />
          <Route path="/disableQR" element={<DisableQR />} />

          <Route path="/qr_order/:restaurantUrl/order-success/:orderId" element={<OrderResult />} />
          

          {/* <Route path="/location" element={<LocationDistance />} /> */}
        </Routes>
      </Router>
    </LocationProvider>
    </CartProvider>
    </ServiceProvider>
   
  );
}

export default App;
